export const getMelApplicabilityValue = (item) => (
  item?.applicability_types || item?.applicability || 'ALL'
);

export const formatMelApplicability = (itemOrValue) => {
  const value = typeof itemOrValue === 'object'
    ? getMelApplicabilityValue(itemOrValue)
    : itemOrValue;
  return String(value || '')
    .split(/[,;|\n]+/)
    .map(item => item.trim())
    .filter(Boolean);
};

export const isGeneralizedMelApplicability = (items) => (
  items.length > 0 && items.every(item => /^A3\d{2}-[A-Z0-9]+$/i.test(item))
);

export const getMelApplicabilityTag = (item) => {
  const entries = formatMelApplicability(item);
  if (!entries.length || (entries.length === 1 && /^ALL$/i.test(entries[0]))) return 'ALL A/C';
  if (isGeneralizedMelApplicability(entries)) return entries.join(' / ');
  if (entries.length === 1) return entries[0];
  return `${entries.length} A/C`;
};
